var PillSize;
(function (PillSize) {
  PillSize["Large"] = 'large';
  PillSize["Medium"] = 'medium';
  PillSize["Small"] = 'small';
  PillSize["XLarge"] = 'xlarge';
  PillSize["XSmall"] = 'xsmall';
})(PillSize || (PillSize = {}));
export { PillSize };